import Principal from '@/views/Principal';
import Historico from '@/views/Historico';
import Login from '@/views/Login';
import Gerenciar from '@/views/Gerenciar';
import Cadastros from '@/views/Cadastros';
import GerenciarRelatorios from '@/views/GerenciarRelatorios';
import RelatorioTempo from '@/views/RelatorioTempo';
import RelatorioMediaEstrela from '@/views/RelatorioMediaEstrela';
import RelatorioAtendEstrela from '@/views/RelatorioAtendEstrela';
import RelatorioAtendTempo from '@/views/RelatorioAtendTempo';
// import FormDefault from '@/components/FormDefault';
import PainelEquipamento from '@/views/PainelEquipamento';
import PainelLeito from '@/views/PainelLeito';
import CadastroTipoChamado from '@/views/CadastroTipoChamado';
import CadastroSetor from '@/views/CadastroSetor';
import CadastroQuarto from '@/views/CadastroQuarto';
import CadastroLeito from '@/views/CadastroLeito';
import CadastroEquipamentos from '@/views/CadastroEquipamentos';
import CadastroProfissional from '@/views/CadastroProfissional';
import CadastroResponsavel from '@/views/CadastroResponsavel';
import Internacao from '@/views/Internacao';
import TipoAtendimento from '@/views/CadastroTipoAtend';
import SubTipoAtendimento from '@/views/CadastroSubTipoAtend';
import TipoFoto from '@/views/CadastroTipoFoto';
import { createRouter, createWebHashHistory } from 'vue-router';
import Relatorios from '@/views/Relatorios';
import * as props from './props';

const rotas = [
    {
        path: '/',
        name: 'Principal',
        component: Principal,
        children: [{
            // path: 'listarDinamico?pIdTipoChamado=:tipoChamadoId&pIdSetor=:setorId',
            path: 'listar/:setorId,:tipoChamadoId',
            name: 'Filtro',
            component: Principal,
            meta: {
                publica: true
            }
        },
        {
            // path: 'listarDinamico?pIdTipoChamado=:tipoChamadoId&pIdSetor=:setorId',
            path: '/',
            name: 'Geral',
            component: Principal,
            meta: {
                publica: true
            }
        }],
        meta: {
            publica: true
        }
    },//Principal
    {
        path: '/historico',
        name: 'Historico',
        component: Historico,
        meta: {
            publica: true
        }
    },//historico
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            publica: true
        }
    },//login
    {
        path: '/gerenciar',
        name: 'Gerenciar',
        component: Gerenciar,
    },//gerenciar
    {
        path: '/cadastros',
        name: 'Cadastros',
        component: Cadastros,
    },//gerenciar
    {
        path: '/gerenciarRelatorios',
        name: 'GerenciarRelatorios',
        component: GerenciarRelatorios,
    },//gerenciarRelatorios
    {
        path: '/relatorioTempo',
        name: "RelatorioTempo",
        component: RelatorioTempo
    },//relatorioTempo
    {
        path: '/RelatorioMediaEstrela',
        name: "RelatorioMediaEstrela",
        component: RelatorioMediaEstrela
    },//RelatorioMediaEstrela
    {
        path: '/RelatorioAtendEstrela',
        name: "RelatorioAtendEstrela",
        component: RelatorioAtendEstrela
    },//RelatorioAtendEstrela
    {
        path: '/RelatorioAtendTempo',
        name: "RelatorioAtendTempo",
        component: RelatorioAtendTempo
    },//RelatorioAtendTempo
    {
        path: '/Relatorios',
        name: "Relatorios",
        component: Relatorios
    },//Relatorios
    {
        path: '/tiposChamados',
        name: 'TiposChamados',
        component: CadastroTipoChamado,
        // component: FormDefault,
        // props: props.propsTipoChamado,
    },//tiposChamados
    {
        path: '/setor',
        name: 'Setor',
        component: CadastroSetor,
        // component: FormDefault,
        // props: props.propsSetor,
    },//setor
    {
        path: '/quarto',
        name: 'Quarto',
        component: CadastroQuarto,
        // component: FormDefault,
        // props: props.propsQuarto,
    },//quarto
    {
        path: '/leito',
        name: 'Leito',
        component: CadastroLeito,
        // component: FormDefault,
        // props: props.propsLeito,
    },//leito
    {
        path: '/profissionais',
        name: 'Profissionais',
        component: CadastroProfissional,
        // component: FormDefault,
        // props: props.propsProfissional,
    },//profissionais
    {
        path: '/responsavel',
        name: 'Responsavel Setor',
        component: CadastroResponsavel,
        // component: FormDefault,
        // props: props.propsResponsavelSetor,
    },//responsavelSetor
    {
        path: '/Equipamentos',
        name: 'Equipamentos',
        component: CadastroEquipamentos,
        // component: FormDefault,
        // props: props.propsEquipamentos,
    },//Equipamentos
    {
        path: '/PainelEquipamento',
        name: 'PainelEquipamento',
        component: PainelEquipamento,
    },//PainelEquipamento
    {
        path: '/PainelLeito',
        name: 'PainelLeito',
        component: PainelLeito,
        props: props.propsLeitoLimpar,
    },//PainelLeito
    {
        path: '/internacao',
        name: 'internacao',
        component: Internacao,
    },//PainelLeito
    {
        path: '/tipoAtendimento',
        name: 'tipoAtendimento',
        component: TipoAtendimento,
    },//PainelLeito
    {
        path: '/subTipoAtendimento',
        name: 'subtipoAtendimento',
        component: SubTipoAtendimento,
    },//PainelLeito
    {
        path: '/tipoFoto',
        name: 'tipoFoto',
        component: TipoFoto,
    },//PainelLeito
];

const roteador = createRouter({
    history: createWebHashHistory(),
    routes: rotas
});

roteador.beforeEach((routeTo, routeFrom, next) => {
    if (!routeTo.meta.publica && !sessionStorage.TokenReguaPainel) {
        return next({
            path: '/'
        });
    }
    next();
});

export default roteador;